import { Injectable } from '@angular/core';
import { ErrorHandlerService } from '@y42/error-handling';
import { AbstractFeatureGitService, getY42GitPath, Y42GitFolders } from '@y42/feature/git';
import { Y42MetadataGitModel } from '@y42/feature/json-schema';
import { GitQuery, GitService } from '@y42/git';
import { Y42FeatureType } from '@y42/json-schema';
import { VisualizationThemeSettingsGitModel, VisualizationThemeStoreModel } from './visualization-theme.model';

@Injectable({ providedIn: 'root' })
export class VisualizationThemeGitService extends AbstractFeatureGitService<
  VisualizationThemeStoreModel,
  Y42GitFolders.VisualizationTheme
> {
  constructor(
    protected readonly git: GitService,
    protected readonly gitQuery: GitQuery,
    protected readonly errorHandlerService: ErrorHandlerService,
  ) {
    super({
      gitQuery,
      git,
      errorHandlerService,
      name: Y42FeatureType.VisualizationTheme,
      basePath: getY42GitPath(Y42GitFolders.VisualizationTheme),
      hydrationDefinition: {
        1: {
          modelType: 'folder',
        },
      },
      models: {
        metadata: {
          fileName: 'metadata.json',
          model: Y42MetadataGitModel,
        },
        settings: {
          fileName: 'settings.json',
          model: VisualizationThemeSettingsGitModel,
        },
      },
    });
  }
}
